"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_2 = require("@osmosys/react");
const react_if_1 = require("react-if");
exports.ConversionCanvasRunConversionViewOverlay = ({ isOpen, disabled, onRun, }) => {
    return (react_1.default.createElement(react_if_1.When, { condition: !isOpen },
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_2.OsmosysOverlay, { rounded: true },
                react_1.default.createElement(react_2.OsmosysButton, { osysName: "Run", size: "lg", color: disabled ? 'dark' : 'success', disabled: disabled, onClick: () => {
                        onRun();
                    } }, disabled
                    ? 'Add sample HTML to run conversion'
                    : 'Click to run conversion')),
            react_1.default.createElement(react_2.OsmosysDiv, { className: "w-100 bg-dark", flexFill: true, style: {
                    height: 300,
                } }))));
};
//# sourceMappingURL=Overlay.js.map